import { createTheme } from "@mantine/core";
import { BRANDCOLORS } from "./BrandColors.js";
const ida = createTheme({
  other: {
    colorTokens: {
      backgrounds: {
        primary: BRANDCOLORS.blue[5],
        secondary: BRANDCOLORS.blue[4],
        primary50: BRANDCOLORS.blue[0],
        light: BRANDCOLORS.grey[1],
        page: BRANDCOLORS.grey[5],
        neutral: BRANDCOLORS.grey[2],
        black: BRANDCOLORS.black[9],
        dark: BRANDCOLORS.black[2],
        primary600: BRANDCOLORS.blue[6],
        primary60080: "rgba(56, 71, 92, 0.8)"
      },
      gradients: {
        dark: `linear-gradient(180deg, ${BRANDCOLORS.blue[5]} 44.6%, ${BRANDCOLORS.blue[4]} 100%)`,
        menuDesktop: `linear-gradient(180deg, ${BRANDCOLORS.blue[5]}, ${BRANDCOLORS.blue[6]})`,
        menuMobile: `linear-gradient(180deg, ${BRANDCOLORS.blue[6]}, ${BRANDCOLORS.blue[5]})`,
        light: `linear-gradient(180deg, rgba(94, 125, 162, 0.10) 0%, rgba(237, 239, 243, 0.10) 100%))`,
        heroImage: `linear-gradient(180deg, rgba(63, 30, 9, 0.00) 9.15%, rgba(63, 30, 9, 0.54) 56.07%)`,
        primary60080: `linear-gradient(180deg, ${BRANDCOLORS.blue[6]} 65.44%, #5E7DA2CC 100%)`,
        primary60010: `linear-gradient(180deg, ${BRANDCOLORS.blue[6]} 65.44%, #5E7DA21A 100%)`,
        black: `linear-gradient(180deg, rgba(63, 30, 9, 0.00) 18%, rgba(0, 0, 0, 0.85) 83%)`
      },
      body: {
        dark: BRANDCOLORS.black[5],
        dark200: BRANDCOLORS.black[2],
        neutral: BRANDCOLORS.grey[7],
        white: BRANDCOLORS.white[5],
        alt: BRANDCOLORS.green[5],
        focus: BRANDCOLORS.black[5],
        primary: BRANDCOLORS.blue[5],
        primary300: BRANDCOLORS.blue[3],
        primary600: BRANDCOLORS.blue[6],
        overlineAlt: BRANDCOLORS.orange[5],
        overlineDefault: BRANDCOLORS.indigo[5]
      },
      buttons: {
        dark: BRANDCOLORS.blue[5],
        secondary: BRANDCOLORS.blue[4],
        light: BRANDCOLORS.white[5],
        black: BRANDCOLORS.black[5],
        neutral: BRANDCOLORS.black[0],
        cta: BRANDCOLORS.cyan[1],
        ctaHover: BRANDCOLORS.cyan[0]
      },
      links: {
        default: BRANDCOLORS.indigo[5],
        hover: BRANDCOLORS.indigo[5],
        visited: BRANDCOLORS.violet[5],
        light: BRANDCOLORS.white[5],
        spot: BRANDCOLORS.cyan[5],
        neutral: BRANDCOLORS.grey[6]
      },
      spot: {
        dark: BRANDCOLORS.cyan[5],
        light: BRANDCOLORS.cyan[5],
        mos: BRANDCOLORS.mos[7],
        pink: BRANDCOLORS.pink[7],
        purple: BRANDCOLORS.purple[7],
        cyan: BRANDCOLORS.cyan[7]
      },
      illustration: {
        dark: BRANDCOLORS.cyan[5],
        light: BRANDCOLORS.cyan[5]
      },
      dividers: {
        dark: BRANDCOLORS.grey[7],
        light: BRANDCOLORS.grey[6],
        white: BRANDCOLORS.white[5],
        white20: "#FFFFFF33",
        // white 5 with 20% opacity. Fix this with the new design tokens.
        spot: BRANDCOLORS.cyan[5],
        spot30: "#65BFF14D"
        // cyan 5 with 30% opacity. Fix this with the new design tokens.
      },
      feedback: {
        warning: BRANDCOLORS.yellow[5],
        error: BRANDCOLORS.red[5],
        success: BRANDCOLORS.green[5],
        information: BRANDCOLORS.indigo[5]
      },
      inputs: {
        primary: BRANDCOLORS.blue[5],
        light: BRANDCOLORS.white[5],
        disabled: BRANDCOLORS.grey[2],
        dark: BRANDCOLORS.grey[4],
        disabledText: BRANDCOLORS.black[5],
        placeholder: BRANDCOLORS.grey[7],
        inverseBg: BRANDCOLORS.grey[6],
        inverseBorder: BRANDCOLORS.grey[6],
        frameBg: BRANDCOLORS.black[0],
        helpTextColor: BRANDCOLORS.black[3]
      },
      icons: {
        dark: BRANDCOLORS.indigo[5],
        light: BRANDCOLORS.white[5],
        neutral: BRANDCOLORS.grey[7],
        black: BRANDCOLORS.black[5],
        secondary: BRANDCOLORS.blue[4]
      },
      stroke: {
        dark: BRANDCOLORS.grey[7],
        light: BRANDCOLORS.grey[6],
        white: BRANDCOLORS.white[5],
        black: BRANDCOLORS.black[5],
        primary: BRANDCOLORS.blue[5],
        secondary: BRANDCOLORS.blue[4]
      }
    }
  }
});
export {
  ida
};
